import React from 'react';

class Badge extends React.Component{

    static defaultProps = {
        pill: false,
        context: "info",
        content: "badge"
    };
    
    render(){
        const { context, pill, content } = this.props;
        return (
            <span className={'badge badge-'+context+' '+(pill?'badge-pill':null)}>{content}</span>
        );
    }
}

export default Badge;

